<template>
  <div
    :class="[
      'space-y-3 mb-4 p-4 border-b border-blue-300/30 max-w-screen-md bg-[var(--fundoForm)] rounded-md',
      { hidden: !show },
    ]"
  >
  <div class="flex justify-between cursor-pointer border border-blue-300/30 p-2 rounded-md" >
    <!-- Title -->
    <h2 class="text-[var(--text)] text-lg font-semibold">{{ form_title }}</h2>
    <div class="cursor-pointer" @click="$emit('cancel')">

      <i class="fa-solid fa-close xl text-[var(--text)]"></i>
    </div>
  </div>
    <!-- Familia -->
    <ValidatedSelect
      name="familia_id"
      label="Família:"
      v-model="formModel.familia_id"
      :options="familias"
      placeholder="Selecionar família..."
      :required="true"
      :show-errors="true"
      :show-prevalidation-warning="true"
      :rules="familiaRule"
    />


    <!-- Descrição -->
    <ValidatedTextarea
      name="descricao"
      label="Descrição:"
      v-model="formModel.descricao"
      placeholder="Descrição da entrada"
      :rows="3"
      :rules="descricaoRule"
    />

    <!-- File Upload -->
    <div class="space-y-2 flex justify-between">
      <label class="text-blue-100 block w-1/6 text-right">Arquivo <br>(JPG/PNG):</label>
      <div class="flex flex-col w-3/4 gap-2">
        <input
          type="file"
          ref="fileInput"
          @change="onFileSelected"
          accept=".jpg,.jpeg,.png"
          class="text-sm border border-[#ccc] p-1 rounded-md w-full text-white"
          :class="{ 'input-required': !selectedFile && !formModel.capa_path }"
        />
        <!-- View current file icon -->
        <!-- Selected file info -->
        <p v-if="selectedFile" class="text-xs text-blue-100">
          Novo arquivo selecionado: {{ selectedFile.name }}
        </p>
        
        <!-- Current file info -->
        <div v-if="formModel.capa_path && !selectedFile" class="flex items-center gap-2">
          <p class="text-xs text-green-400">
            <i class="fa-solid fa-file"></i> Arquivo atual: {{ formModel.capa_path }}
          </p>
          <button
            @click="viewImage(formModel.id)"
            type="button"
            class="bg-purple-600 hover:bg-purple-700 text-white p-1 rounded text-xs"
            title="Ver imagem"
          >
            <i class="fa-solid fa-eye"></i>
          </button>
        </div>
        
        <!-- Upload messages -->
        <p v-if="uploadMessage" :class="uploadMessageClass" class="text-xs">
          {{ uploadMessage }}
        </p>
        
      </div>
      
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <button
        class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        @click="onSave"
        :disabled="loading"
      >
        Salvar
      </button>
      <button
        class="bg-gray-400 hover:bg-gray-500 text-[var(--text)] px-4 py-2 rounded"
        @click="onCancel"
        :disabled="loading"
      >
        Cancelar
      </button>
    </div>
  </div>

  <div
    v-if="showImageModal"
    class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
    @click.self="closeImageModal"
  >
    <div class="bg-[#5D5D98] rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-auto glass-app popup-content">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-white text-lg font-semibold">Visualizar Imagem</h3>
        <button
          @click="closeImageModal"
          class="text-white hover:text-gray-200"
        >
          <i class="fa-solid fa-times text-2xl"></i>
        </button>
      </div>

      <!-- Image Viewer -->
      <div class="flex justify-center items-center">
        <img
          v-if="imageUrl"
          :src="imageUrl"
          alt="Visualização da Imagem"
          class="max-w-full max-h-[70vh] object-contain rounded"
          @error="handleImageError"
        />
        <div v-else class="flex items-center justify-center h-[70vh]">
          <i class="fa-solid fa-spinner fa-spin text-4xl text-[var(--label)]"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidatedInput from "@/components/ValidatedInput.vue";
import ValidatedSelect from "@/components/ValidatedSelect.vue";
import ValidatedTextarea from "@/components/ValidatedTextarea.vue";
import { commonRules } from "@/validations/rules/common.js";
import * as yup from "yup";
import axios from 'axios';

export default {
  name: "CapaForm",
  components: {
    ValidatedSelect,
    ValidatedTextarea,
  },
  props: {
    show: Boolean,
    familias: Array,
    fornecedores: Array,
    initialEditModel: {
      type: Object,
      default: () => ({
        familia_id: null,
        descricao: "",
      }),
    },
    form_title: String,
  },
  data() {
    return {
      formModel: { ...this.initialEditModel },
      familiaRule: commonRules.required("Família"),
      descricaoRule: yup.string().nullable(),
      loading: false,
      selectedFile: null,
      uploadMessage: "",
      uploadMessageClass: "",
      showImageModal: false,
      imageUrl: null,
    };
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        const validExtensions = [".jpg", ".jpeg", ".png"];
        const fileName = file.name;
        const fileExtension = fileName.substring(fileName.lastIndexOf("."));
    
        if (!validExtensions.includes(fileExtension.toLowerCase())) {
          this.uploadMessage = "Apenas arquivos de imagem (.jpg, .jpeg, .png) são permitidos";
          this.uploadMessageClass = "text-red-400";
          this.selectedFile = null;
          return;
        }
    
        if (file.size > 10 * 1024 * 1024) {
          // 10MB limit
          this.uploadMessage = "Arquivo muito grande (máx 10MB)";
          this.uploadMessageClass = "text-red-400";
          this.selectedFile = null;
          return;
        }
    
        this.selectedFile = file;
        this.uploadMessage = "";
      }
    },
    async onSave() {
      this.loading = true;
      const payload = {
      ...this.formModel,
      familia_id: this.formModel.familia_id?.id || this.formModel.familia_id,
    };
      
      // Include the file if one is selected
      if (this.selectedFile) {
        payload.file = this.selectedFile;
      }
      
      this.$emit("save", payload);
      this.loading = false;
    },
    onCancel() {
      this.$emit("cancel");
    },
    setUploadMessage(message, messageClass) {
      this.uploadMessage = message;
      this.uploadMessageClass = messageClass;
    },
    clearFileInput() {
      this.selectedFile = null;
      this.uploadMessage = "";
      this.uploadMessageClass = "";
      this.$refs.fileInput.value = "";
    },
    viewCurrentFile() {
      if (this.formModel.caminho_pdf && this.formModel.id) {
        const baseURL = process.env.VUE_APP_URL_BASE;
        const selectedSchema = localStorage.getItem('selectedSchema') || '';
        const fileUrl = `${baseURL}/api/v1/entradaestoque/arquivo/${this.formModel.id}/?schema=${selectedSchema}`;
        window.open(fileUrl, "_blank");
      }
    },
    async viewImage(capaId) {
      try {
        const baseURL = process.env.VUE_APP_URL_BASE;
        const response = await axios.get(`${baseURL}/api/v1/capa/foto/${capaId}/`, {
          responseType: 'blob', // Ensure the response is a Blob
        });

        // Create a URL for the Blob
        this.imageUrl = URL.createObjectURL(response.data);
        this.showImageModal = true;
      } catch (error) {
        console.error('Error fetching image:', error);
        this.$emit('error', 'Erro ao carregar a imagem.');
      }
    },
    closeImageModal() {
      this.showImageModal = false;
      this.imageUrl = null;
    },
    handleImageError() {
      this.imageUrl = null;
      this.$emit('error', 'Erro ao carregar a imagem.');
    },
    formatFileSize(size) {
      if (!size) return "-";
      const i = Math.floor(Math.log(size) / Math.log(1024));
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + " " + ["B", "KB", "MB", "GB", "TB"][i];
    },
    formatDate(date) {
      if (!date) return "-";
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    },
  },
  watch: {
    initialEditModel: {
      handler(newVal) {
       const familia = this.familias.find(f => f.id === newVal.familia_id);
      this.formModel = {
        ...newVal,
        familia_id: familia || newVal.familia_id, // Set to object if found, otherwise keep the id
      };
        // Clear file input when switching to a different entrada
        this.clearFileInput();
      },
      deep: true,
      immediate: true,
    },
    formModel: {
      handler(newVal) {
        this.$emit("edit-model-changed", newVal);
      },
      deep: true,
    },
  },
  emits: ["edit-model-changed", "open-contact-crud", "save", "cancel"],
};
</script>
